import React from "react";
import { Stack, TextInput, NumberInput, Text, Paper } from "@mantine/core";
import { AR_FORM_NUMBER_INPUT_PROPS } from "../helpers/arFormUtils";
import { formatFundAmount } from "../helpers/approvalFundListFundFields";

const OrderArFormSubscribedAmount = ({ form }) => {
  const {
    fundName,
    fundCurrency,
    subscribedAmount,
    contractNo,
    minSubscriptionAmount,
  } = form?.values ?? {};

  if (!String(fundName ?? "").trim()) {
    return (
      <Text size="sm" color="dimmed">
        Please select a fund in the previous step.
      </Text>
    );
  }

  const amountError = form.errors?.subscribedAmount;
  const minimumLabel =
    minSubscriptionAmount != null
      ? `${formatFundAmount(minSubscriptionAmount)} ${fundCurrency ?? ""}`.trim()
      : null;

  return (
    <Stack spacing="lg" maw={520}>
      <Paper withBorder p="md" radius="sm">
        <Text size="xs" color="dimmed" mb={4}>
          Selected fund 已選基金
        </Text>
        <Text size="sm" weight={600}>
          {fundName}
        </Text>
      </Paper>

      <TextInput
        label="Fund Currency 基金貨幣"
        value={fundCurrency ?? ""}
        readOnly
        variant="filled"
        size="md"
      />

      <NumberInput
        label="Subscribed/ Switch-in Amount 認購/轉入金額"
        required
        withAsterisk
        hideControls
        min={0}
        precision={2}
        placeholder="0.00"
        error={amountError}
        value={subscribedAmount ?? ""}
        size="md"
        onChange={(value) => {
          form.markUserEdited?.();
          form.setFieldValue("subscribedAmount", value);
          form.setFieldValue(
            "productSubscribed",
            value != null && value !== "" && Number(value) > 0
          );
        }}
        {...AR_FORM_NUMBER_INPUT_PROPS}
      />

      <TextInput
        label="Contract No. 合約編號"
        value={contractNo ?? ""}
        size="md"
        onChange={(event) => {
          form.markUserEdited?.();
          form.setFieldValue("contractNo", event.currentTarget.value);
        }}
      />

      {minimumLabel && (
        <Text size="sm" color="dimmed">
          Minimum subscribed/ switch-in amount 最低認購/轉入金額: {minimumLabel}
        </Text>
      )}
    </Stack>
  );
};

export default OrderArFormSubscribedAmount;
